// eslint-disable-next-line import/prefer-default-export
export const partitionFieldsAssignUnassign = ({
  currentData = [],
  updatedData = [],
}) => {
  const currentFieldsIds = currentData.map((u) => u.id);
  const newFieldsIds = updatedData.map((o) => o.value);

  const assign = updatedData
    .filter((a) => !currentFieldsIds.includes(a.value)).map((a) => ({ id: a.value }));
  const unassign = currentData
    .filter((u) => !newFieldsIds.includes(u.id)).map((u) => ({ id: u.id }));

  return {
    assign,
    unassign,
  };
};
